import React, { useState } from "react";
import { useRegisterContext } from "../../context/ContextProvider";
import AddApliance from "../AddApliance";
// import { useRegisterContext } from "../../context/ContextP rovider";

const SpendStep3 = () => {
	const { activeStyle, setActiveStyle } = useRegisterContext();
	const [isOption, setIsOption] = useState(false);
	return (
		<form className="container spend__form-step3">
			<div className="spend__form-step3__container">
				<p className="form__title">Add your Residential Appliances here</p>
				<div className="appliance__input">
					<label htmlFor="electricityNumber">Appliance</label>
					<input
						type="text"
						name="electricityNumber"
						placeholder="Electric cooker"
						required
					/>
				</div>
				<div className="appliance__input-container">
					<div className="appliance__input2">
						<label htmlFor="test">Power rating (Watts)</label>
						<input
							type="text"
							name="test"
							placeholder="200W"
							value=""
							onChange={() => {}}
							required
						/>
					</div>
					<div className="appliance__input2">
						<label htmlFor="test">Quantity</label>
						<input placeholder="2" required />
					</div>
				</div>
				<div className="appliance__input">
					<label>Hours on per day</label>
					<input placeholder="12" required />
				</div>
				<p className="add__more" onClick={() => setIsOption(!isOption)}>
					+ Add more appliance
				</p>
				<button
					className="residence__submit-button"
					onClick={() => setActiveStyle(activeStyle + 1)}
				>
					Calculate{" "}
				</button>
			</div>
			{isOption && (
				<div className={`${isOption ? "add__more-appliances" : "none"}`}>
					<div className="v1"></div>
					<div className="appliance__details">
						<p className="remove__all" onClick={() => setIsOption(!isOption)}>Remove all</p>
						<AddApliance id={1} quantity={2}/>
						<AddApliance id={2} quantity={1}/>
					</div>
				</div>
			)}
		</form>
	);
};

export default SpendStep3;
